import React, { PropTypes } from 'react';
import Select from 'react-select';
import axios from './../../../../constants/axios';


class SelectAsyncSaleForm extends React.Component {
   constructor(props) {
      super(props);
      this.presentItemList = [];
   }

   onBlur = () => {
      this.props.input.onBlur(this.props.input.value.value);
   };

   itemLoaders = (name) => {
      const { link } = this.props;
      return axios(`${link}/${name}`)
         .then((res) => {
            this.presentItemList = res.data;
            let n = res.data.map(function (i) {
               return {
                  label: i.name,
                  value: i.id
               };
            });
            return { options: n };
         });
   };


   render() {
      const { input, initial, label, minimumInput, meta: { touched, error } } = this.props;
      return (
         <div className="form-group" >
            {label && <label>{label}</label>}
            <Select.Async {...input} loadOptions={this.itemLoaders}
                          initial={initial}
                          minimumInput={minimumInput}
                          onBlur={this.onBlur} />
            {touched && error && <span
               className="input-validation-error"
            >{error}</span>}
         </div>
      );
   }
}


SelectAsyncSaleForm.propTypes = {
   input: PropTypes.object,
   link: PropTypes.string.isRequired,
   meta: PropTypes.object,
   label: PropTypes.string,
   minimumInput: PropTypes.number,
   initial: PropTypes.array
};
export default SelectAsyncSaleForm;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/FormHelper/SelectAsyncSaleForm.js
 **/